export default "__VITE_ASSET__jmxR7Lzp__"